var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 30,
    viewBox: "0 0 194 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2071 27.7123H7.19974V9.71457H20.0074V20.5092H14.3767V17.3312H16.8314V12.8925H10.3745V24.5344H24.0324V5.46426H3.17476V27.7123H0V2.2876H27.2071V27.7123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6532 30L36.978 16.5915L36.8984 13.8106L46.6438 0L50.4249 2.67335L41.6814 15.0639L49.2412 24.5572L53.865 17.1972L49.173 17.5703L48.8066 12.9495L58.0972 12.2109L60.2398 15.7556L51.423 29.7901L47.6532 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1589 30L106.834 16.5915L106.915 13.8106L97.1695 0L93.3871 2.67335L102.131 15.0639L94.5708 24.5572L89.947 17.1972L94.6391 17.5703L95.0054 12.9495L85.7149 12.2109L83.5723 15.7556L92.3891 29.7901L96.1589 30Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6827 0.154822L63.5005 2.14355L76.6418 29.8342L80.824 27.8455L67.6827 0.154822Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6572 0.122626L62.9058 27.8159L67.0519 29.8789L80.8033 2.18557L76.6572 0.122626Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.764 11.4537L110.942 15.2791L114.764 19.1045L118.586 15.2791L114.764 11.4537Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.339 29.0439H116.239L128.206 11.7404L119.989 4.3539L122.965 1.03687L134.103 11.0474L124.74 24.5849H132.339V29.0439Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.779 29.0439H155.678L167.645 11.7404L159.429 4.3539L162.404 1.03687L173.541 11.0474L164.18 24.5849H171.779V29.0439Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.168 15.1515L145.806 12.7864L143.443 15.1515L145.806 17.5167L148.168 15.1515Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.668 28.9935L135.961 15.4168L145.573 1.08643L155.678 14.7681L145.668 28.9935ZM141.135 15.3055L145.649 21.8195L150.449 14.7693L145.742 8.82196L141.134 15.3068L141.135 15.3055Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M184.601 29.6801L180.577 27.7693L186.375 15.5381H177.696V0.399658H191.872V4.85862H182.15V11.0792H193.418L184.601 29.6801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53bad224978ae8a84991da3372acf307.svg";
export { ForwardRef as ReactComponent };